import styled from 'styled-components';

import { IconButton } from '@xing-com/button';
import { scale150, spaceL, spaceXL } from '@xing-com/tokens';

const ImageCropperZoomContainer = styled.div`
  align-items: center;
  align-self: center;
  display: flex;
  gap: ${spaceL};
  margin-bottom: ${spaceXL};
  width: 60%;
`;

const ImageCropperControlButton = styled(IconButton)`
  width: ${scale150};
  &:not(:disabled) {
    cursor: pointer;
  }
`;

export const Styled = {
  ImageCropperZoomContainer,
  ImageCropperControlButton,
};
